// removed by extract-text-webpack-plugin
module.exports = {"sidenav":"_1QBabfQg"};


//////////////////
// WEBPACK FOOTER
// ./app/customers/containers/parent/parent.styles.scss
// module id = 512
// module chunks = 0